<template>
    <div>
        <Alert v-if="requiresAdditionalInfo" type="light-warning" class="mb-5">
            <template v-slot:icon>
                <i class="fas fa-exclamation-triangle"/>
            </template>
            <div class="text-lg font-weight-bold">
                {{ __('store-sale-invoice.sale_not_available') }}
            </div>
            <div>
                {{ __('store-sale-invoice.sale_add_data') }}<br>
                {{ __('store-sale-invoice.sale_edit_data') }}
            </div>
        </Alert>

        <SettingsCardTitle>
            {{ __('store.legal_info') }}
            <template v-slot:subtitle>
                {{ __('store.manage_legal_info') }}
            </template>
        </SettingsCardTitle>

        <div v-if="isStoreInGermany || isStoreInAustria">
            <StoreInvoiceSettingsGermany v-if="isStoreInGermany"
                                         :requires-additional-info="requiresAdditionalInfo"
                                         v-model="settings"
            />
            <StoreInvoiceSettingsAustria v-else-if="isStoreInAustria"
                                         :requires-additional-info="requiresAdditionalInfo"
                                         v-model="settings"
            />
        </div>

        <div class="row">
            <div v-for="document in legalDocuments" class="col-md-6">
                <StoreLegalDocument :label="__('store.document_types.' + document.type)"
                                    :description="__('actions.edit_thing_for', {
                                        thing: __('store.document_types_with_article.' + document.type),
                                        for: __('general.your_store')
                                    })"
                                    :exists="hasLegalDocument(document.smcField)"
                                    :exists-text="__('general.own_document_exists')"
                                    :not-exist-text="__('general.own_document_doesnt_exist')"
                                    @edit="editDocument(document.type)"
                />
            </div>
        </div>

        <DividerDotted class="mb-3"/>
        <SaveAndEnableButton :for="settings" @click="save"/>
    </div>
</template>

<script>
import Navigation from "@pages/Stores/Edit/Nav/Navigation.vue";
import Alert from "@components/Alert.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";
import StoreInvoiceSettingsAustria from "@components/Store/Edit/StoreInvoiceSettingsAustria.vue";
import StoreInvoiceSettingsGermany from "@components/Store/Edit/StoreInvoiceSettingsGermany.vue";
import SettingsCardTitle from "@components/Form/SettingsCardTitle.vue";
import DividerDotted from "@components/Form/DividerDotted.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import StoreLegalDocument from "@components/Store/Edit/StoreLegalDocument.vue";
import {StoreLegalDocumentType} from "@generated/storeLegalDocumentType";

export default {
    layout: Navigation,

    components: {
        StoreLegalDocument,
        FormGroupNew,
        DividerDotted,
        SettingsCardTitle,
        StoreInvoiceSettingsGermany,
        StoreInvoiceSettingsAustria,
        SaveAndEnableButton,
        Alert
    },

    props: {
        store: Object,
        existingSettings: Object,
    },

    data() {
        return {
            settings: this.$inertia.form(this.existingSettings),
            legalDocuments: [
                {
                    type: StoreLegalDocumentType.TOS,
                    smcField: 'agb'
                },
                {
                    type: StoreLegalDocumentType.Imprint,
                    smcField: 'imprint'
                },
                {
                    type: StoreLegalDocumentType.WithdrawalRights,
                    smcField: 'withdrawal_rights'
                },
            ]
        }
    },

    methods: {
        save() {
            this.settings.post(this.$route('store.edit.legal.update', this.store.id));
        },

        editDocument(type) {
            this.$inertia.visit(this.$route('store.edit.legal.document', [this.store.id, type]))
        },

        hasLegalDocument(property) {
            return !!this.store.attributes[property];
        },
    },

    computed: {
        storeCountry() {
            return this.store.attributes.address.country.toLowerCase();
        },

        isStoreInGermany() {
            return this.storeCountry === 'de'
        },

        isStoreInAustria() {
            return this.storeCountry === 'at'
        },

        requiresAdditionalInfo() {
            if (this.isStoreInGermany) {
                return !this.existingSettings.ust_id;
            } else if (this.isStoreInAustria) {
                return !this.existingSettings.reg_id;
            }

            return false;
        }
    }
}
</script>
